var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { BASE_BORDER_WIDTH, createUIElement, SPACING_M, SPACING_S, SPACING_XL } from "../helpers";
import { Text, TEXT_SIZE, TEXT_WEIGHT, TEXT_WHITE_SPACE } from "../Text";
import { STACK_GAP, StackView } from "../StackView";
var HeaderGroup = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 600;\n    line-height: ", ";\n"], ["\n    font-weight: 600;\n    line-height: ", ";\n"])), SPACING_XL);
var GroupOptions = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    & + [data-group-options='true'] {\n        border-top: ", " solid ", ";\n        margin-top: ", ";\n        padding-top: ", ";\n    }\n"], ["\n    & + [data-group-options='true'] {\n        border-top: ", " solid ", ";\n        margin-top: ", ";\n        padding-top: ", ";\n    }\n"])), BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorBorderMain;
}, SPACING_S, SPACING_M);
export var ColumnGroupsLayout = createUIElement('ColumnGroupsLayout', function (_a, ref) {
    var className = _a.className, columns = _a.columns, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "columns", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(StackView, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'column-groups-layout', className: "vm-ColumnGroupsLayout " + className, gap: STACK_GAP.xxl, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), columns.map(function (_a, rowKey) {
        var groups = _a.groups;
        return (React.createElement("div", { key: "column-groups-layout-row-" + rowKey }, groups.map(function (_a, groupKey) {
            var title = _a.title, render = _a.render;
            return (React.createElement(GroupOptions, { key: "column-groups-layout-group-option-" + rowKey + "-" + groupKey, "data-group-options": true },
                title && (React.createElement(HeaderGroup, { whitespace: TEXT_WHITE_SPACE.nowrap, weight: TEXT_WEIGHT.bold, size: TEXT_SIZE.m, key: "column-groups-layout-subheader-" + rowKey + "-" + groupKey }, title)),
                render()));
        })));
    })));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=ColumnGroupsLayout.js.map